<template>
  <div
    class="notification-point-list-section"
    :class="{ 'notification-point-list-section--is-pc': isPc }"
  >
    <ul class="notification-point-list-section__list">
      <li v-for="item in listData" :key="item.id" class="notification-point-list-section__item">
        <notification-point-item-parts :itemData="item" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import NotificationPointItemParts, {
  PointData,
} from '@/components/NotificationPane/NotificationPane/parts/NotificationPointItemParts.vue'
import DeviceInfo from '@/util/DeviceInfo'

export default defineComponent({
  name: 'NotificationPointListSection',
  components: { NotificationPointItemParts },
  props: {
    listData: {
      type: Array as PropType<PointData[]>,
      required: true,
    },
  },
  setup() {
    const isPc = DeviceInfo.isForPC()
    return {
      isPc,
    }
  },
})
</script>

<style scoped lang="scss">
.notification-point-list-section {
  max-width: 800px;
  margin: 0 auto;

  &__list {
    border-top: 1px solid $black10;

    .notification-point-list-section--is-pc & {
      border-top: none;
    }
  }

  &__item {
    border-bottom: 1px solid $black10;
  }
}
</style>
